const HOST_URL_TOPUP = "https://103.31.127.28/api/web/index.php/smart-gate";
const HOST_URL_SEND_SMS = "https://mkt.vivas.vn:9380/SMSBNAPINEW"
export { HOST_URL_TOPUP, HOST_URL_SEND_SMS};
